export const environment = {
	production: true,

	APP_ENV: 'stagingecsomag',
	COMMIT_HASH: 'bd46f0460a16017152e218b87b2546506d07a069',
	API_URL: '/api/',
	SITE_CONFIG: 'ecsomag-hu',
	DPM_URL: 'https://gls-dpm.staging.moonproject.io/widget/gls-dpm.js?v=20240616-01',
	SERVICE_SENTRY_DSN_PUBLIC: 'https://5a13b643c8734a229a945a68fc411205@o76075.ingest.sentry.io/5622220',
};
